import { useEffect, useState } from "react";

/**
 * Thin red-orange progress bar tracking page scroll progress.
 */
export const ScrollProgress = () => {
    const [pct, setPct] = useState(0);

    useEffect(() => {
        const onScroll = () => {
            const h = document.documentElement;
            const scrollTop = h.scrollTop || document.body.scrollTop;
            const max = h.scrollHeight - h.clientHeight;
            const p = max > 0 ? (scrollTop / max) * 100 : 0;
            setPct(p);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onScroll);
        };
    }, []);

    return (
        <div
            data-testid="scroll-progress"
            aria-hidden="true"
            className="fixed top-0 left-0 right-0 z-[60] pointer-events-none"
        >
            <div
                className="h-[2px] bg-[#F0493E] transition-[width] duration-150 ease-out shadow-[0_0_12px_rgba(240,73,62,0.55)]"
                style={{ width: `${pct}%` }}
            />
        </div>
    );
};
